import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Loader2Icon } from 'lucide-react';
import { cn } from '../../lib/utils';

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  useLocale();

  return (
    <Loader2Icon
      aria-label={t('ui.loading')}
      className={cn('size-4 animate-spin', className)}
      role="status"
      {...props}
    />
  );
}

export { Spinner };
